<app-dialog-header [title]="'general.api_translations_form_download_title'"
                   [withConfirm]="true" (closed)="close()"></app-dialog-header>
<mat-dialog-content>
  <app-datepicker [disabled]="isLoading" [(dateStart)]="startDate" [(dateEnd)]="endDate"
                  [datePickerConfig]="{autoBindDates: true, range: true, label: 'general.api_translations_form_download_date', maxDate: maxDate}"></app-datepicker>
</mat-dialog-content>
<app-dialog-footer *ngIf="!isLoading" [dialogActions]="dialogActions"></app-dialog-footer>
<ng-template #dialogActions>
    <button mat-button (click)="close()">{{('general.api_general_close')  | translate}}</button>
    <button mat-flat-button color="primary" [disabled]="!isValid" (click)="isValid && download()">{{'general.api_translations_form_download' | translate}}</button>
</ng-template>
<app-loader [loading]="isLoading" [size]="64"></app-loader>
